import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Tabs } from '@treetop/shared/model';

@Injectable({
  providedIn: 'root',
})
export class DisableTreeService {
  public selectedTabChangeSubject = new BehaviorSubject<Tabs>(Tabs.components);

  resetTreeState() {
    this.selectedTabChangeSubject.next(Tabs.components);
  }
}
